<div class="flex-container flex-center flex-col full-height menu-container">
  <!-- Messages Section -->
  <div class="flex-container flex-col message-container">
    <h3>Message Testing</h3>
    <select name="Messages" id="messages" [(ngModel)]="messageCode">
      @for (message of Object.keys(messages); track message; let i = $index) {
        <option [ngValue]="message">
          {{ message }}:
          {{ Object.values(messages)[i].errorName }}
          @if (Object.values(messages)[i].isFullScreen) {
            <span> (Fullscreen)</span>
          }
        </option>
      }
    </select>
    <button class="btn btn-primary" (click)="showMessage()">
      Display Message
    </button>
  </div>

  <!-- Referrer Section -->
  <div class="flex-container flex-col message-container">
    <h3>Referrer Testing</h3>
    <input
      type="text"
      [(ngModel)]="referrer"
      placeholder="Enter url to set as referrer" />
    <button class="btn btn-primary" (click)="setReferrer()">
      Set Referrer
    </button>
  </div>

  <!-- Logging Service Section -->
  <div class="flex-container flex-col message-container">
    <h3>Logging Service Testing</h3>

    <div class="logging-form">
      <label for="log-type">Log Type:</label>
      <input
        id="log-type"
        type="text"
        [(ngModel)]="logType"
        placeholder="e.g., debug_test, user_action, error"
        [disabled]="isLoggingTest" />

      <label for="log-data">Log Data (JSON):</label>
      <textarea
        id="log-data"
        [(ngModel)]="logData"
        placeholder='{"action": "button_click", "elementId": "test-button"}'
        rows="3"
        [disabled]="isLoggingTest"></textarea>

      <label for="force-activity-id">Force Activity ID (Optional):</label>
      <input
        id="force-activity-id"
        type="text"
        [(ngModel)]="forceActivityId"
        placeholder="Leave empty to use current activity ID"
        [disabled]="isLoggingTest" />
    </div>

    <div class="logging-buttons">
      <button
        class="btn btn-primary"
        (click)="testLoggingService()"
        [disabled]="isLoggingTest">
        {{ isLoggingTest ? 'Testing...' : 'Test Logging' }}
      </button>

      <button
        class="btn btn-secondary"
        (click)="resetLogTest()"
        [disabled]="isLoggingTest">
        Reset
      </button>
    </div>

    <!-- Results Display -->
    @if (lastLogResult !== null) {
      <div class="logging-result">
        <div [ngClass]="lastLogResult ? 'success-message' : 'error-message'">
          {{ lastLogResult ? '✓ Logging successful!' : '✗ Logging failed' }}
        </div>
      </div>
    }

    @if (logError) {
      <div class="error-message"><strong>Error:</strong> {{ logError }}</div>
    }

    <!-- Debug Information -->
    <div class="debug-info">
      <details>
        <summary><strong>Debug Information</strong></summary>
        <div class="debug-details">
          <p><strong>Current State:</strong></p>
          <ul>
            <li>Is Testing: {{ isLoggingTest ? 'Yes' : 'No' }}</li>
            <li>
              Last Result:
              {{
                lastLogResult === null
                  ? 'None'
                  : lastLogResult
                    ? 'Success'
                    : 'Failed'
              }}
            </li>
            <li>Has Error: {{ logError ? 'Yes' : 'No' }}</li>
          </ul>
        </div>
      </details>
    </div>

    <!-- Info about the logging service -->
    <div class="logging-info">
      <small>
        <strong>Info:</strong> Logs are sent to the AWS S3 bucket configured in
        aws-exports.js via Amplify Storage. The loggingBucket config (like
        "stage-amira-logging") is used as a folder prefix within that bucket.
        Check the browser network tab and console for detailed results. Feature
        flag "enableLoggingService" must be enabled for actual uploads. Timeout
        is set to 10 seconds to prevent hanging.
      </small>
    </div>
  </div>
</div>
